import React from 'react';

const MessageIcon = ({ active = false }) => {
  return (
    <svg
      id="local_post_office_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <path id="Path_6124" data-name="Path 6124" d="M0,0H24V24H0Z" fill="none" />
      <path
        id="Path_6125"
        data-name="Path 6125"
        d="M22,6a2.006,2.006,0,0,0-2-2H4A2.006,2.006,0,0,0,2,6V18a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2ZM20,6l-8,5L4,6Zm0,12H4V8l8,5,8-5Z"
        fill={active ? '#58B9C1' : '#ededed'}
      />
    </svg>
  );
};

export default MessageIcon;
